import React from 'react';
import { useIntl } from 'react-intl';

import { DataDrivenLogo } from '../../../../../../components/data-driven-logo';
import { FormattedCurrency } from '../../../../../../components/formatted-currency';
import { FlexRow, FlexColumn } from '../../../../../../ui-components/components/flex';
import { Text, TextType } from '../../../../../../ui-components/components/text';
import { messages } from '../../../../../messages';
import styles from '../styles.module.css';

/**
 * Display component for add funds step when coming from create label flow
 * @param {object} props
 * @param {{code?: string, value?: number}} props.orderRates - Order rates object with value and code
 * @param {number} [props.providerId] - Provider ID for the DataDrivenLogo
 * @param {string} [props.serviceName] - Service name (e.g., "First Class Mail")
 * @param {boolean} [props.isMultiCarrier] - Whether multiple carriers are selected in bulk flow
 * @returns {React.ReactElement}
 */
export const CreateLabelDisplay = ({ orderRates, providerId, serviceName, isMultiCarrier }) => {
  const intl = useIntl();

  const displayText = isMultiCarrier ? intl.formatMessage(messages.multiCarrier) : serviceName;

  if (!orderRates?.value) {
    return null;
  }

  return (
    <FlexColumn className={styles['label-cost-card']}>
      <Text textType={TextType.H4} value={messages.labelCost} />
      <FlexRow className={styles['label-cost-content']}>
        <FlexRow className={styles['carrier-info']}>
          {providerId && !isMultiCarrier ? (
            <DataDrivenLogo className={styles['carrier-icon']} logoType='icon' providerId={providerId} />
          ) : null}
          <Text className={styles['carrier-name']} textType={TextType.Paragraph} value={displayText} />
        </FlexRow>
        <Text
          className={styles['label-cost-amount']}
          textType={TextType.H4}
          value={<FormattedCurrency currencyCode={orderRates.code} value={orderRates.value} />}
        />
      </FlexRow>
    </FlexColumn>
  );
};
